import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import moment from 'moment';
import { longDateFormat } from '../../config/';
import { paymentFrequencyOptions } from '../../config/paymentFrequencyOptions';
import paymentPropTypes from '../../states/payments/propTypes';

export const translateFrequencyValueToLabel = (value) => {
	const translatedFrequency = get(
		paymentFrequencyOptions.filter((x) => x.value === value),
		'[0].label',
		value
	);
	return translatedFrequency;
};

const RepeatingPaymentDescription = ({ payment, tomorrow }) => {
	const tomorrowDate = tomorrow || moment().add(1, 'day');

	const getFormattedDate = (date) => {
		if (tomorrowDate.isSame(date, 'day')) {
			return `${date.format(longDateFormat)} (Tomorrow)`;
		}
		return date.format(longDateFormat);
	};

	let stopping;
	switch (payment.stopPaymentOption) {
		case 'on-cancel':
			stopping = 'when I cancel';
			break;
		case 'on-number':
			stopping = `after ${payment.stopPaymentOnNumber} payments`;
			break;
		case 'on-date':
			stopping = `on ${getFormattedDate(payment.stopPaymentOnDate)}`;
			break;
		default:
			break;
	}

	const frequency = translateFrequencyValueToLabel(payment.frequency).toLowerCase();
	const startDate = getFormattedDate(payment.date);

	return (
		<div className="c-m-payment-review__repeating">
			Repeat this payment <strong>{frequency}</strong> starting from <strong>{startDate}</strong> and stopping{' '}
			<strong>{stopping}</strong>.
		</div>
	);
};

RepeatingPaymentDescription.propTypes = {
	payment: PropTypes.shape(paymentPropTypes).isRequired,
	tomorrow: PropTypes.shape({}),
};

RepeatingPaymentDescription.defaultProps = {
	tomorrow: null,
};

export default RepeatingPaymentDescription;
